class Sale {
  constructor({
    date_of_purchase,
    destination,
    fulfillment_status,
    order_id,
    origin,
    passenger_id,
    product_name,
    product_price,
    shipper,
    store_id,
    store_name,
    updated_at,
    booking_id,
    relaunched,
    status_cd,
    order,
    id,
    shipping_id,
    quantity,
    shipping_estimated_date,
    related,
    pack_id,
    pack_size,
    pack_items
  }) {
    this.date_of_purchase = date_of_purchase;
    this.destination = destination;
    this.external_id = order.external_id;
    this.fulfillment_status = fulfillment_status;
    this.order_id = order_id;
    this.origin = origin;
    this.passenger_id = passenger_id;
    this.product_name = product_name;
    this.product_price = product_price;
    this.shipper = shipper;
    this.store_id = store_id;
    this.store_name = store_name;
    this.updated_at = updated_at;
    this.booking_id = booking_id;
    this.relaunched = relaunched;
    this.status_cd = status_cd;
    this.order = order;
    this.id = id;
    this.shipping_id = shipping_id;
    this.quantity = quantity;
    this.shipping_estimated_date = shipping_estimated_date;
    this.related = related;
    this.pack_id = pack_id;
    this.pack_size = pack_size;
    this.pack_items = pack_items;
  }

  // Un envio agrupa mas de un pedido de ML (ver docs/2026-08-13-mercadoflex-
  // pack-grouping.md). Con el flag apagado o para otros integradores,
  // pack_size siempre es 1 o undefined.
  isPack() {
    return (this.pack_size || 1) > 1;
  }

  // Todos los order ids del pack: el representante (external_id) + related.
  packOrderIds() {
    return this.isPack() ? [this.external_id, ...(this.related || [])] : [this.external_id];
  }

  // Detalle por pedido para la fila expandible. Si el backend aun no manda
  // pack_items (documentos sincronizados antes de agregarlo), se arma un
  // detalle minimo solo con los ids conocidos.
  packItems() {
    if (!this.isPack()) return [];
    if (this.pack_items?.length > 0) return this.pack_items;

    return this.packOrderIds().map((external_id) => ({
      external_id,
      order_id: external_id === this.external_id ? this.order_id : null,
      product_name: external_id === this.external_id ? this.product_name : null,
      quantity: external_id === this.external_id ? this.quantity : null,
      product_price: external_id === this.external_id ? this.product_price : null,
    }));
  }
}

export default Sale
